import { StyleSheet } from 'aphrodite';
import { THEME } from '../../../../../../../components-v2/Theme/theme';

export const styleSheet = StyleSheet.create({
	audienceModeScreenContainer: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.lg,
		alignItems: 'flex-start',
	},
	audienceModeScreenLeft: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		flex: 1,
	},
	audienceModeScreenRight: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
		flex: 2,
	},
	audienceModeScreenHeading: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: 20,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.primary.main,
		margin: 0,
	},
	audienceModeScreenSubhead: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
	},
	audienceModeScreenCards: {
		display: 'flex',
		flexDirection: 'row',
		gap: THEME.spacing.md,
	},
	audienceModeScreenCard: {
		flex: 1,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: THEME.spacing.md,
		borderRadius: THEME.common.borderRadius,
		border: `1.5px solid ${THEME.colors.border.main}`,
		background: 'none',
		textAlign: 'left',
		cursor: 'pointer',
	},
	audienceModeScreenCardSelected: {
		borderColor: THEME.colors.primary.main,
		boxShadow: `0 0 0 3px color-mix(in srgb, ${THEME.colors.primary.main} 12%, transparent)`,
	},
	audienceModeScreenCardTitle: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	audienceModeScreenCardDescription: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
	},
	audienceModeScreenRadioDot: {
		width: 20,
		height: 20,
		borderRadius: '50%',
		border: `1.5px solid ${THEME.colors.border.main}`,
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		flexShrink: 0,
	},
	audienceModeScreenRadioDotSelected: {
		borderColor: THEME.colors.primary.main,
	},
	audienceModeScreenRadioInner: {
		width: 9,
		height: 9,
		borderRadius: '50%',
		backgroundColor: THEME.colors.primary.main,
	},
	audienceModeScreenCardHeader: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	audienceModeScreenContinue: {
		width: '100%',
	},

	audienceRowContainer: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
	},
	audienceRowLabel: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		flexShrink: 0,
	},
	audienceRowLabelIconEmpty: {
		color: THEME.colors.icon.gray,
	},
	audienceRowLabelIconFilled: {
		color: THEME.colors.primary.main,
	},
	audienceRowAddButton: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		borderRadius: THEME.common.borderRadius,
		border: `1.5px dashed ${THEME.colors.border.main}`,
		background: 'none',
		cursor: 'pointer',
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
	},
	audienceRowEmptyHint: {
		fontStyle: 'italic',
		color: THEME.colors.text.light,
	},
	audienceRowAdvancedCount: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},
	audienceRowError: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.danger.main,
		flexBasis: '100%',
	},
	audienceRowEditLink: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.primary.main,
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: 0,
		textDecoration: 'underline',
		flexBasis: '100%',
	},

	addTagPopoverContent: {
		width: 240,
		padding: 0,
	},
	addTagPopoverInputWrap: {
		padding: `${THEME.spacing.sm}px ${THEME.spacing.sm}px 0`,
	},
	addTagPopoverSectionLabel: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xxs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: '0.08em',
		color: THEME.colors.text.light,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		marginTop: THEME.spacing.xs,
	},
	addTagPopoverList: {
		maxHeight: 176,
		overflowY: 'auto',
		padding: `0 0 ${THEME.spacing.xs}px`,
	},
	addTagPopoverOption: {
		display: 'block',
		width: '100%',
		textAlign: 'left',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		':hover': {
			backgroundColor: THEME.colors.hover.light,
		},
	},
	addTagPopoverError: {
		padding: `${THEME.spacing.sm}px`,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.danger.main,
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		alignItems: 'flex-start',
	},

	summarySidebarContainer: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.md,
	},
	summarySidebarList: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
	},
	summarySidebarItem: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		justifyContent: 'space-between',
		gap: THEME.spacing.sm,
	},
	summarySidebarCampaignName: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: 13,
		fontWeight: THEME.typography.fontWeights.standard,
		color: THEME.colors.text.main,
		flex: 1,
		...THEME.common.truncate,
	},
	summarySidebarStatus: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
		whiteSpace: 'nowrap',
	},
	summarySidebarStatusError: {
		color: THEME.colors.danger.main,
		fontWeight: THEME.typography.fontWeights.semibold,
	},
	summarySidebarCta: {
		width: '100%',
	},

	modeBadge: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		padding: `2px ${THEME.spacing.sm}px`,
		borderRadius: 18,
		border: `1px solid ${THEME.colors.border.main}`,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.semibold,
		color: THEME.colors.text.light,
	},
	modeBadgeRow: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.sm,
	},
	modeChangeLink: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.primary.main,
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		padding: 0,
		textDecoration: 'underline',
	},

	legendStrip: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: THEME.spacing.md,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		marginTop: THEME.spacing.md,
		marginBottom: THEME.spacing.sm,
		backgroundColor: THEME.colors.background.main,
		borderRadius: THEME.common.borderRadius,
	},
	legendItem: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		color: THEME.colors.text.light,
	},

	editAudienceFlyoutHeader: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
		padding: `${THEME.spacing.sm}px ${THEME.spacing.md}px`,
		borderBottom: THEME.common.border,
	},
	editAudienceFlyoutEyebrow: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: '0.08em',
		color: THEME.colors.text.light,
		margin: 0,
	},
	editAudienceFlyoutTitle: {
		fontFamily: THEME.typography.fontFamilies.sora,
		fontSize: THEME.typography.fontSizes.lg,
		fontWeight: THEME.typography.fontWeights.bold,
		color: THEME.colors.text.main,
		margin: 0,
	},
	editAudienceFlyoutExcludeSection: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.sm,
		padding: `${THEME.spacing.md}px ${THEME.spacing.lg}px`,
		borderTop: THEME.common.border,
	},
	editAudienceFlyoutSectionLabel: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.xs,
		fontWeight: THEME.typography.fontWeights.bold,
		letterSpacing: '0.06em',
		color: THEME.colors.text.light,
		textTransform: 'uppercase' as const,
		margin: 0,
	},
	editAudienceFlyoutExcludeHelper: {
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		margin: 0,
	},
	editAudienceFlyoutChips: {
		display: 'flex',
		flexDirection: 'row',
		flexWrap: 'wrap',
		gap: THEME.spacing.xs,
	},
	editAudienceFlyoutExcludeButton: {
		display: 'inline-flex',
		alignItems: 'center',
		gap: THEME.spacing.xs,
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		borderRadius: THEME.common.borderRadius,
		border: `1.5px dashed ${THEME.colors.border.main}`,
		background: 'none',
		cursor: 'pointer',
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.light,
		alignSelf: 'flex-start',
	},
	editAudienceFlyoutAutocompleteWrap: {
		display: 'flex',
		flexDirection: 'column',
		gap: THEME.spacing.xs,
	},
	editAudienceFlyoutAutocompleteList: {
		display: 'flex',
		flexDirection: 'column',
		borderRadius: THEME.common.borderRadius,
		border: THEME.common.border,
		overflow: 'hidden',
	},
	editAudienceFlyoutAutocompleteOption: {
		display: 'block',
		width: '100%',
		textAlign: 'left',
		padding: `${THEME.spacing.xs}px ${THEME.spacing.sm}px`,
		fontFamily: THEME.typography.fontFamilies.lexend,
		fontSize: THEME.typography.fontSizes.sm,
		color: THEME.colors.text.main,
		background: 'none',
		border: 'none',
		cursor: 'pointer',
		':hover': {
			backgroundColor: THEME.colors.hover.light,
		},
	},
});
